<template>
  <div class="landingpage-new">
    <div class="pc-style">
      
      <div class="pc-topbar">
        <div class="landingpage-new-topbar">
          <a class="to-home" href="https://www.simplybrand.com/"></a>
          <el-button type="home-email" @click="showinfobox"></el-button>
          <el-button type="home-login" @click="goLogin()"></el-button>
        </div>
      </div>
      <div class="pc-main">
        <img src="@/assets/img/landingpagenew/PC1-2.jpg" />
        <img src="@/assets/img/landingpagenew/PC2.jpg" />
        <img src="@/assets/img/landingpagenew/PC3.jpg" />
        <img src="@/assets/img/landingpagenew/PC4.jpg" />
        <img src="@/assets/img/landingpagenew/PC5.jpg" />
        <img src="@/assets/img/landingpagenew/PC6.jpg" />
        <img src="@/assets/img/landingpagenew/PC7.jpg" />
      </div>
    </div>
    <div class="h5-style">
      <div class="imggroup">
        <img src="@/assets/img/landingpagenew/h5/simply-Brand_01.png" />
        <img src="@/assets/img/landingpagenew/h5/simply-Brand_02.png" />
        <img src="@/assets/img/landingpagenew/h5/simply-Brand_03.png" />
        <img src="@/assets/img/landingpagenew/h5/simply-Brand_04.png" />
        <img src="@/assets/img/landingpagenew/h5/simply-Brand_05.png" />
        <img src="@/assets/img/landingpagenew/h5/simply-Brand_06.png" />
        <img src="@/assets/img/landingpagenew/h5/simply-Brand_07.png" />
        <img src="@/assets/img/landingpagenew/h5/simply-Brand_08.png" />
      </div>
      <img class="clickimg" src="@/assets/img/landingpagenew/h5/a337607e-71c5-46b2-87cf-9e2d29600ba5.jpg" @click="showinfobox1" />
    </div>
    <el-dialog
      title="取得联系"
      class="infoboxform"
      :show-close="false"
      :visible.sync="showform"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="30%">
      <el-form ref="form" :rules="rules" :model="form" label-width="55px" size="small">
        <el-form-item label="姓名" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="电话" prop="tel">
          <el-input v-model="form.tel" type="tel"></el-input>
        </el-form-item>
        <el-form-item label="品牌">
          <el-input v-model="form.brand"></el-input>
        </el-form-item>
        <el-form-item label="公司">
          <el-input v-model="form.company"></el-input>
        </el-form-item>
        <el-form-item label="邮箱">
          <el-input v-model="form.email" type="email"></el-input>
        </el-form-item>
      </el-form>      
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="showform = false; loading = false; form = {}">取 消</el-button>
        <el-button size="mini" type="primary" @click="sendEmail('form')" :loading="loading">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="取得联系"
      class="infoboxform"
      :show-close="false"
      :visible.sync="showform1"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="80%">
      <el-form ref="form" :rules="rules" :model="form" label-width="55px" size="small">
        <el-form-item label="姓名" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="电话" prop="tel">
          <el-input v-model="form.tel" type="tel"></el-input>
        </el-form-item>
        <el-form-item label="品牌">
          <el-input v-model="form.brand"></el-input>
        </el-form-item>
        <el-form-item label="公司">
          <el-input v-model="form.company"></el-input>
        </el-form-item>
        <el-form-item label="邮箱">
          <el-input v-model="form.email" type="email"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="showform1 = false; loading = false; form = {}">取 消</el-button>
        <el-button size="mini" type="primary" @click="sendEmail('form')" :loading="loading">确 定</el-button>
      </span>
    </el-dialog>
    <FooterBar />
  </div>
</template>

<script>
import FooterBar from '@/components/FooterBar/FooterBar.vue'
export default {
  components: {
    FooterBar
  },
  data(){
    let checkphone = (rule, value, callback) => {
      let rex = /^1(3|4|5|6|7|8|9)\d{9}$/
      if(false === rex.test(this.form.tel)){
        callback(new Error('手机号码输入有误'))
      }else{
        callback()
      }
    }    
    return{
      showform: false,
      showform1: false,
      loading: false,
      form: {
        name: '',
        from: '',
        tel: '',
        brand: '',
        company: '',
        email: '',
        href: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        tel: [
          { required: true, message: '请输入电话', trigger: 'blur' },
          { validator: checkphone, trigger: 'blur'}
        ],
      }
    }
  },
  mounted(){

    /**
     * 添加客服图标
     */
    // let pagehref = window.location.href
    
    // let kchatid = ''
    // if(pagehref.indexOf('?bd') != -1){
    //   kchatid = '1041131'
    // }else{
    //   kchatid = '1040403'
    // }
    // let script = document.createElement('script')
    // script.type = 'text/javascript'
    // script.src = 'https://assets-cdn.kf5.com/supportbox/main.js?' + (new Date).getDay()
    // script.id = 'kf5-provide-supportBox'
    // script.charset = "utf-8"
    // script.setAttribute('kchat-id', kchatid)
    // script.setAttribute('kf5-domain', 'simplybrand.kf5.com')
    // document.getElementsByTagName('head')[0].appendChild(script)
  },

  methods: {
    goLogin: function(){
      this.$router.push({path: '/Login/Default?lang=zh'})
    },

    showinfobox: function(){
      this.showform = true
    },

    showinfobox1: function(){
      this.showform1 = true
    },

    sendEmail: function(formName){
      let that = this
      that.form.from = that.$route.query.ref == undefined ? '非推广来源' : that.$route.query.ref
      that.form.href = window.location.href
      that.$refs[formName].validate((valid) => {
        if (valid) {
          // let query = {
          //   data: that.form
          // }
          that.loading = true
          // let url = '//similarpic.simplybrand.com/api/userInfo/sendMail'
          let url ='/sendMail'
          $.ajax(url, {
            type: "POST",
            data: that.form,
            success: function(data) {
              console.log(data)
              that.showform = false
              that.loading = false
              that.form = {}
              that.$message({
                showClose: true,
                message: '提交成功，我们将会尽快与您取得联系',
                type: 'success'
              })
            },
            error: function(response) {
              console.log(response)
              that.$message.error('系统错误，请稍后再试')
            }
          })
        } else {
          this.$message.error('请填写正确的信息')
          return false
        }
      })
    },

  }
}
</script>

<style>
.pc-topbar{
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: #fff;
}
.landingpage-new img{
  width: 100%;
}
.landingpage-new-topbar{
  position: relative;
  background-image: url('../assets/img/landingpagenew/PC1-1.jpg');
  background-position: center center;
  background-repeat: no-repeat;
  background-size: auto 70px;
  margin: auto;
}
.landingpage-new-topbar .el-button{
  border: 0;
  background-color: transparent;
  position: absolute;
  padding: 0;
}
.landingpage-new-topbar .el-button:hover,
.landingpage-new-topbar .el-button:active,
.landingpage-new-topbar .el-button:focus{
  background-color: transparent;
}
.landingpage-new-topbar a{
  position: absolute;
}
.h5-style{
  padding-bottom: 110px;
}
.pc-style{
  display: none;
}
.kf5-support-chat{
  display: none;
}
.footer-bar{
  display: none;
}
img.clickimg{
  position: fixed;
  bottom: 0;
  left: 0;
  cursor: pointer;
}
@media (min-width: 750px) {
  .footer-bar{
    display: inherit;
  }
  .pc-main{
    padding-top: 40px;
  }
  .h5-style{
    display: none;
  }
  .pc-style{
    display: inherit;
  }
  .kf5-support-chat{
    display: inherit;
  }
  .landingpage-new-topbar{
    width: 780px;
    height: 40px;
    background-size: auto 40px;
  }
  .landingpage-new-topbar .el-button{
    width: 60px;
    height: 20px;
    top: 13px;
  }
  .landingpage-new-topbar a{
    display: block;
    width: 110px;
    height: 20px;
    left: 60px;
    top: 14px;
  }
  .landingpage-new-topbar .el-button.el-button--home-email{
    right: 110px;
  }
  .landingpage-new-topbar .el-button.el-button--home-login{
    right: 44px;
  }
}
@media (min-width: 980px) {
  .pc-main{
    padding-top: 50px;
  }
  .landingpage-new-topbar{
    width: 990px;
    height: 50px;
    background-size: auto 50px;
  }
  .landingpage-new-topbar .el-button{
    width: 75px;
    height: 30px;
    top: 13px;
  }
  .landingpage-new-topbar a{
    display: block;
    width: 170px;
    height: 30px;
    left: 90px;
    top: 15px;
  }
  .landingpage-new-topbar .el-button.el-button--home-email{
    right: 145px;
  }
  .landingpage-new-topbar .el-button.el-button--home-login{
    right: 63px;
  }
}
@media (min-width: 1180px) {
  .pc-main{
    padding-top: 60px;
  }
  .landingpage-new-topbar{
    width: 1200px;
    height: 60px;
    background-size: auto 60px;
  }
  .landingpage-new-topbar .el-button{
    width: 90px;
    height: 35px;
    top: 15px;
  }
  .landingpage-new-topbar a{
    display: block;
    width: 170px;
    height: 30px;
    left: 110px;
    top: 20px;
  }
  .landingpage-new-topbar .el-button.el-button--home-email{
    right: 180px;
  }
  .landingpage-new-topbar .el-button.el-button--home-login{
    right: 80px;
  }
}
@media (min-width: 1600px) {
  .pc-main{
    padding-top: 70px;
  }
  .landingpage-new-topbar{
    width: 1600px;
    height: 70px;
    background-size: auto 70px;
  }
  .landingpage-new-topbar .el-button{
    width: 110px;
    height: 40px;
    top: 18px;
  }
  .landingpage-new-topbar a{
    display: block;
    /* background-color: #f00; */
    width: 200px;
    height: 40px;
    left: 230px;
  }
  .landingpage-new-topbar .el-button.el-button--home-email{
    right: 310px;
  }
  .landingpage-new-topbar .el-button.el-button--home-login{
    right: 190px;
  }
}
</style>